export enum NodeName {
  Doc = 'doc',
  Paragraph = 'paragraph',
  Text = 'text',
  HardBreak = 'hard_break',
  OrderedList = 'ordered_list',
  BulletList = 'bullet_list',
  ListItem = 'list_item',
  Mention = 'mention',
  LegacyMention = 'legacy_mention',
}
